<label class="file-label">
  <input class="file-input" type="file" name="{{ name }}" (change)="fileChanged($event)" accept="image/jpeg" required>
  <span class="file-cta">
    <span class="file-label"><span class="font-size-18 font-weight-medium" appTranslate="Anhang hochladen"></span></span>
  </span>
</label>
